import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useConfigContext } from "../ConfigContext";
import grassApi from "@/services/agribot/grassland";
import { ApiContext } from "./context";

export const ApiProvider = ({ children }) => {
  const { apiEp } = useConfigContext();
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [api, setApi] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setApi(null);
      setError(null);
      setLoading(false);
      return;
    }

    const setUpApi = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = await getAccessTokenSilently();

        // Create an Axios instance with authentication
        const axiosInstance = axios.create({
          baseURL: apiEp,
          timeout: 10000,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        setApi(new grassApi({ axios: axiosInstance }));
      } catch (err) {
        console.error("Failed to setup API client:", err);
        setError("Failed to initialize API client");
        setApi(null);
      } finally {
        setLoading(false);
      }
    };

    setUpApi();
  }, [getAccessTokenSilently, apiEp, isAuthenticated]);

  return (
    <ApiContext.Provider value={{ api, loading, error }}>
      {children}
    </ApiContext.Provider>
  );
};
